import { render, staticRenderFns } from "./ReporteStockDelete.vue?vue&type=template&id=5e20203a"
import script from "./ReporteStockDelete.vue?vue&type=script&lang=js"
export * from "./ReporteStockDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports